import React, { useEffect, useRef, useState } from 'react'
import { getExport } from 'helpers/api_helper'

// The club report of a Tenis10 event (Tudor 2026-10-29, canvas PaSCeReaWiyLChipRLDrib): A4 portrait, as an XLS and as a PDF, the same
// file SportyaOS downloads (sportya-api `GET /exports/events/:eventId/club-report`).
export const clubReportUrl = (id, format) => '/exports/events/' + id + '/club-report?format=' + format

export default function EventReports({ id, name, tShirt, tenis10 = false }) {
  const [busy, setBusy] = useState(''), [error, setError] = useState('')
  const active = useRef(false), alive = useRef(true)
  useEffect(() => () => { alive.current = false }, [])
  const file = (suffix, extension) => (name || 'Event').replace(/[\\/:*?"<>|]/g, '-') + suffix + '.' + extension
  const download = async ({ url, fileName }, label) => {
    if (active.current) return
    active.current = true; setBusy(label); setError('')
    let objectUrl
    try {
      const response = await getExport(url, { responseType: 'blob' })
      if (!(response.data instanceof Blob) || response.data.size === 0 || /json|html/.test(response.data.type)) throw new Error('Invalid report')
      if (!alive.current) return
      objectUrl = URL.createObjectURL(response.data)
      const link = document.createElement('a'); link.href = objectUrl; link.download = fileName
      document.body.appendChild(link); link.click(); link.remove()
    } catch { if (alive.current) setError('The report could not be downloaded. Try again.') }
    finally { if (objectUrl) URL.revokeObjectURL(objectUrl); active.current = false; if (alive.current) setBusy('') }
  }
  const xls = suffix => ({ url: '/events/' + id + '/xls' + suffix, fileName: file(suffix.replace('/', '-'), 'xlsx') })
  const clubReport = format => ({ url: clubReportUrl(id, format), fileName: file('-club', format) })
  const reports = [[xls(''), 'Download report'],
    ...(tenis10 ? [[clubReport('xlsx'), 'Download report for clubs (XLS)'], [clubReport('pdf'), 'Download report for clubs (PDF)']]
      : [[xls('/club'), 'Download report for clubs']]),
    [xls('/draw'), 'Download lucky draw report'], ...(tShirt ? [[xls('/tshirts'), 'Download T-shirt report']] : [])]
  return <section><h3>Reports</h3>{reports.map(([report, label]) =>
    <button key={label} type="button" className="btn btn-outline-primary mr-2 mb-2" disabled={Boolean(busy)} onClick={() => download(report, label)}>{busy === label ? 'Preparing report…' : label}</button>)}
    {busy && <p role="status">Preparing your download…</p>}{error && <p className="text-danger" role="alert">{error}</p>}
  </section>
}
